<ng-container *transloco="let t">
    <div
        class="bazis-dropdown bazis-dropdown_action"
        [class.bazis-dropdown_top]="direction() === 'top'"
        clickOutside
        (clickOutside)="hideDropdown()"
        [excludeElement]="trigger"
    >
        @if (typeTrigger() === 'button') {
            <bazis-button
                #trigger
                class="bazis-dropdown__trigger"
                [size]="sizeTrigger() || 'regular'"
                [fill]="fillTrigger() || 'solid'"
                [color]="colorTrigger()"
                [active]="open"
                (click)="toggleDropdown($event)"
            >
                @if (iconStart()) {
                    <bazis-icon
                        slot="start"
                        [icon]="iconStart()"
                        [size]="iconSize()"
                    ></bazis-icon>
                }
                {{ t(titleKey(), titleParams()) }}

                @if (iconEnd()) {
                    <bazis-icon
                        [slot]="titleKey() ? 'end' : 'icon-only'"
                        [icon]="iconEnd()"
                        [size]="iconSize()"
                    ></bazis-icon>
                }
            </bazis-button>
        }

        @if (typeTrigger() === 'link') {
            <bazis-link
                #trigger
                class="bazis-dropdown__trigger bazis-dropdown__trigger_link"
                borderStyle="none"
                [size]="sizeTrigger() || ''"
                (click)="toggleDropdown($event)"
            >
                @if (iconStart()) {
                    <bazis-icon
                        slot="start"
                        [icon]="iconStart()"
                        [size]="iconSize()"
                    ></bazis-icon>
                }
                {{ t(titleKey(), titleParams()) }}
                @if (iconEnd()) {
                    <bazis-icon
                        [slot]="titleKey() ? 'end' : ''"
                        [icon]="iconEnd()"
                        [size]="iconSize()"
                    ></bazis-icon>
                }
            </bazis-link>
        }

        @if (open) {
            <div class="bazis-dropdown__body">
                <ng-content></ng-content>
            </div>
        }
    </div>
</ng-container>
